module.exports = __webpack_public_path__ + "static/media/project.ac0d610f.jpg";